import TrashIcon from '../../components/icons/TrashIcon';
import { useDraggable } from '@dnd-kit/core';
import { CourseOption } from '../../types/course.response';
import { getCourseKey } from '../../utils/courseUtils';

export type DragSource = 'sidebar-saved' | 'sidebar-unassigned' | 'semester';

interface CourseCardForDraggingProps {
  courseOption: CourseOption;
  source: DragSource;
  onDeleteCourse: (course: CourseOption) => void;
}

export default function CourseCardForDragging({
  courseOption,
  source,
  onDeleteCourse,
}: CourseCardForDraggingProps) {
  const courseKey = getCourseKey(courseOption);

  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `sidebar-draggable-${courseKey}`,
    data: { courseOption, source },
  });

  const handleDeleteCourse = (e: React.MouseEvent) => {
    e.stopPropagation();
    onDeleteCourse(courseOption);
  };
  
  return (
    <div 
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      className={`mb-3 w-full flex items-stretch rounded-md shadow-sm border cursor-grab active:cursor-grabbing transition-all ${
        isDragging 
          ? 'opacity-50 border-blue-500 shadow-lg' 
          : 'border-gray-200 hover:shadow-md'
      }`}
    >
      <div className="flex-shrink-0 bg-gray-100 rounded-l-md px-1.5 py-2 hover:bg-gray-200 transition-colors flex items-center">
        <div className="grid grid-cols-2 gap-0.5">
          <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
          <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
          <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
          <div className="w-1 h-1 bg-gray-400 rounded-full"></div>
        </div>
      </div>
      
      <div className="flex items-center justify-between gap-2 flex-1 min-w-0 px-3 py-2 bg-white rounded-r-md">
        <div className="flex-1 min-w-0 overflow-hidden">
          <p className="text-xs text-gray-600 truncate">
            {courseOption.courseInfo.subject} {courseOption.courseInfo.number}
          </p>
          <p className="text-sm truncate">
            {courseOption.courseInfo.titleShort}
          </p>
          {courseOption.topic && (
            <p className="text-xs text-gray-500 truncate">
              {courseOption.topic}
            </p>
          )}
        </div>
        
        <button
          onClick={handleDeleteCourse}
          onPointerDown={(e) => e.stopPropagation()}
          onMouseDown={(e) => e.stopPropagation()}
          className="p-1 hover:bg-gray-200 rounded cursor-pointer"
          aria-label="Remove course"
        >
          <TrashIcon className="w-4 h-4 text-gray-600" />
        </button>
      </div>
    </div>
  );
}
